import { useController, Control } from 'react-hook-form';
import BaseToggleSwitch from '.';

interface ReactHookFormToggleSwitchProps {
  name: string;
  control: Control<any>;
  label?: string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}

export default function ReactHookFormToggleSwitch({
  name,
  control,
  label,
  disabled,
  ...props
}: ReactHookFormToggleSwitchProps) {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <BaseToggleSwitch
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      errorMessage={error?.message}
      disabled={disabled}
      {...props}
    />
  );
}
